import axios from "axios";

function getDefaultApiBaseUrl() {
  const configured = String(process.env.REACT_APP_API_URL || "").trim();
  if (configured) {
    return configured.replace(/\/$/, "");
  }

  if (typeof window !== "undefined" && /^https?:$/i.test(window.location.protocol)) {
    const isLocalHost = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
    return isLocalHost ? "http://localhost:3001" : `${window.location.origin}/api`;
  }

  return "http://localhost:3001";
}

export const API_BASE_URL = getDefaultApiBaseUrl();

const API = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false
});

API.interceptors.request.use((config) => {
  try {
    const admin = JSON.parse(localStorage.getItem("admin") || "null");
    if (admin?.session_token) {
      config.headers = config.headers || {};
      config.headers["x-admin-token"] = admin.session_token;
    }
  } catch {
    // Ignore invalid local storage.
  }
  return config;
});

export function getMediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${String(path).startsWith("/") ? path : `/${path}`}`;
}

export default API;
